import { Info } from "lucide-react"

import { Link } from "../ui/Link"

export function StudentWorkInfoIcon() {
  return (
    <Link
      title="What is Student Work? ↗"
      href="https://www.classkick.com/student-work"
      className="tw-ml-2"
      variant="ghost"
      external
    >
      <Info size={12} />
    </Link>
  )
}
